import { lightTheme } from "../../../theme/theme";

type Theme = typeof lightTheme;
export const FooterStyles = (theme: Theme) => {
  const ft = theme.footerTheme;

  return {
    root: {
      backgroundColor: ft.background,
      color: ft.text,
      fontFamily: "'Poppins', sans-serif",
      // marginTop: 32,
      borderTop: `1px solid ${ft.border}`,
      width: "100%",
      overflowX: "clip" as const,
      boxSizing: "border-box" as const,
    },
    container: {
      maxWidth: "100%",
      width: "100%",
      margin: "0 auto",
      padding: "32px 12px",
      boxSizing: "border-box" as const,
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 18,
      alignItems: "start",
    } as const,

    brand: { display: "flex", flexDirection: "column" as const, gap: 10 },
    brandTitle: { fontSize: "clamp(16px, 2vw, 18px)", fontWeight: 800 },
    tagline: {
      opacity: 0.9,
      fontSize: "clamp(13px, 1.8vw, 14px)",
      color: ft.muted,
      marginTop: 10,
    },

    colTitle: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 800,
      fontStyle: "italic",
      marginBottom: 10,
      letterSpacing: 0.3,
      color: ft.text,
      fontSize: "clamp(1rem, 2.5vw, 1.5rem)",
    },

    contactItem: {
      fontSize: "clamp(13px, 1.8vw, 14px)",
      color: ft.muted,
      margin: "20px 0",
      lineHeight: 1.5,
      wordBreak: "break-word" as const,
    },
    contactStrong: { color: ft.text, fontWeight: 600 },
    socialRow: { display: "flex", alignItems: "center", gap: 8, marginTop: 8 },

    bottom: {
      marginTop: 22,
      paddingTop: 14,
      borderTop: `1px solid ${ft.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap" as const,
      fontSize: 13,
      color: ft.muted,
    },

    locationOverlay: {
      position: "absolute" as const,
      inset: 0,
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-start",
      background:
        "linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,.55) 100%)",
      padding: "0.75rem",
    },
    mapFrameWrap: {
      position: "relative",
      width: "100%",
      maxWidth: "100%",
      height: "clamp(160px, 28vw, 220px)",
      borderRadius: 16,
      overflow: "hidden",
      boxShadow: "0 8px 24px rgba(0,0,0,.25)",
      margin: "0.5rem 0 0.5rem",
      background: "#111",
      boxSizing: "border-box" as const,
    },
    mapFrame: { border: 0, display: "block", width: "100%", height: "100%" },
    footerDirectionLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      textDecoration: "none",
      color: "inherit",
    },

    hoursList: {
      listStyle: "none",
      padding: 0,
      margin: "0.25rem 0 0",
      display: "grid",
      gap: "0.25rem",
    },
    hoursItem: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "clamp(12px, 1.7vw, 13px)",
      color: ft.muted ?? ft.text,
      opacity: 0.9,
      gap: 8,
    },

    bottomRight: {
      marginInlineStart: "auto",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      color: ft.muted ?? ft.text,
      fontSize: "clamp(11px, 1.6vw, 12px)",
      opacity: 0.9,
    },
    badge: {
      border: "1px solid rgba(255,255,255,.16)",
      padding: "0.15rem 0.5rem",
      borderRadius: 999,
      whiteSpace: "nowrap" as const,
    },
    dot: {
      width: 4,
      height: 4,
      borderRadius: 999,
      background: "rgba(255,255,255,.35)",
      display: "inline-block",
      flex: "0 0 4px",
    },

    // FooterStyles.ts (or wherever s.brand is defined)
    writtenBrand: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start", // was probably 'center'
      justifyContent: "flex-start",
      textAlign: "start" as const,
    },
  };
};
